import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbInsightObjectTypeConfigurationRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-object-type-configuration',
	path: '/jira/servicedesk/insight/configure/object-type/:objectTypeId',
};
